import { withStyles } from '@material-ui/styles'
import React from 'react'

import styles from '../../styles/Footer.styles'

const Footer = props => {
  const { paletteName, emoji, classes } = props

  return (
    <footer className={classes.PaletteFooter}>
      {paletteName}
      <span className={classes.emoji}>{emoji}</span>
    </footer>
  )
}

export default withStyles(styles)(Footer)
